import React from "react"
import { FontAwesomeIcon } from '../../../components'
import styles from './CircleIcon.module.scss'
import { gradients } from '../../../constants'

function CircleIcon({
  clicked,
  style,
  faColor,
  disabled,
  color,
  faicon,
  children,
  size,
}){

  const handleClicked = () => {
    if (disabled) { return }
    clicked()
  }

  if (!size) { size = '48px' }
  if (!color) { color = 'gray' }
  if (disabled) { color = 'gray' }
  if (!style) { style = {} }

  const colors = {
    gray: '#aaaaaa',
    green: gradients.brandGreen
  }

  const _styles = {
    container: {
      background: colors[color],
      cursor: 'pointer'
    },
    icon: {
      height: size,
      width: size,
    }
  }

  return(
    <div style={{ ..._styles.container, ...style }} className={styles.container} onClick={handleClicked}>
      <div style={_styles.icon} className={styles.Icon}>
        {
          children ?
            children :
            <FontAwesomeIcon faicon={faicon} color={'white'}/>
        }
      </div>
    </div>
  )
}


export default CircleIcon;
